<!--
 * @Author: xuquantong
 * @Date: 2022-04-26 19:53:58
 * @LastEditors: xuquantong
 * @LastEditTime: 2023-09-18 19:54:08
 * @Description: 商详页之----商品标题、副标题、同系列、参数、PK
-->
<template>
  <div class="product-info-wrap" v-track="trackData.baseInfo(obj)">
    <!-- 标签、标题 -->
    <div class="product-info-title">
      <div class="product-tag" v-if="skuInfo.commoditySkuTag && skuInfo.commoditySkuTag.tagIcon">
        <img :src="skuInfo.commoditySkuTag.tagIcon.replace(/https|http/, 'https')" alt />
      </div>
      <div id="product-info-title" class="title" tabindex="0" aria-live="polite" aria-hidden="false">
        {{ skuInfo.commoditySkuBaseInfo.skuName }}
        <template v-if="currentSuiteInfo && currentSuiteInfo.id">{{ currentSuiteInfo.name }}</template>
      </div>
    </div>
    <!-- 卖点 -->
    <sell-points :sku-info="skuInfo" :current-suite-info="currentSuiteInfo" @changeShowButton="changeShowButton" />
    <!-- <template v-if="installmentInit || isGroupon"></template> 暂时找不到需要不展示的场景-->
    <!-- 闹钟预告抢购 -->
    <div class="product-info-yugao" v-if="commodityQuickBuyPreHeat">
      <div class="yu-gao" @click="jump" tabindex="0">
        <img class="img" src="./imgs/nao-zhong.png" alt="" />
        <div class="right" v-if="isAtmospherePreHot">
          <span class="text2">
            限时特惠价 ￥{{
              currentSuiteInfo && currentSuiteInfo.suitQuickBuyPrePrice
                ? currentSuiteInfo.suitQuickBuyPrePrice
                : commodityQuickBuyPreHeat.quickBuyPreHeatPrice
            }}
          </span>
          <span>{{ commodityQuickBuyPreHeat.preTimeTxt }}</span>
        </div>
        <div class="right" v-else>
          <span class="text2">
            抢购价 ￥{{
              currentSuiteInfo && currentSuiteInfo.suitQuickBuyPrePrice
                ? currentSuiteInfo.suitQuickBuyPrePrice
                : commodityQuickBuyPreHeat.quickBuyPreHeatPrice
            }}
          </span>
          <span>{{ commodityQuickBuyPreHeat.preTimeTxt }}</span>
          <i></i>
        </div>
      </div>
    </div>
    <!-- 服务类商品 -->
    <div class="product-info-service" v-if="isServiceGoods">
      <div class="tip">
        *购买即视为同意
        <a class="terms" href="javascript:void(0)" @click="linkTo">《vivo 服务条款》</a>
      </div>
    </div>
    <!-- 同系列 -->
    <div class="product-info-series" v-if="relatedSeriesInfo.relateSeries && !isLottery">
      <div class="tong-xi-lie">
        <div class="left">同系列</div>
        <v-scroll-x class="right" :data="relatedSeriesInfo.relateSeries">
          <template v-slot="{ data: item }">
            <div
              class="item"
              @click="toDetail(item)"
              v-track="trackData.baseInfoClick({ sku_id: skuId, info_content: 3, recommand_spu: item.spuId })"
              tabindex="0"
            >
              <div class="text" role="button">{{ item.modelName }}</div>
              <div class="right-icon">
                <v-icon class="icon" name="arrow-right-v3" />
              </div>
            </div>
          </template>
        </v-scroll-x>
      </div>
    </div>
    <!-- 文字链 -->
    <div class="product-info-textlink" v-if="!isVipFirstBuy && textLinks && textLinks.length > 0">
      <div
        class="wen-zi-lian"
        v-for="(item, index) in textLinks"
        :key="index"
        v-track="trackData.baseInfoClick({ sku_id: skuId, info_content: 2 })"
      >
        <!-- <a v-if="item.linkUrl" class="link" :href="item.linkUrl">{{ item.text }}</a> -->
        <div v-if="item.linkUrl" class="link" @click="openNewWebview(item.linkUrl)">{{ item.text }}</div>
        <template v-else>
          <span class="link">{{ item.text }}</span>
        </template>
        <i class="tips-icon" v-if="item.linkUrl"></i>
      </div>
    </div>

    <!-- 定金预售流程 -->
    <EarnestMoney :sku-info="skuInfo" />
    <!-- 一分团步骤说明 -->
    <GroupRundown v-if="isLottery" />
    <!-- 配件适配关系 -->
    <part-adapted-type
      v-if="!isShieldPartActivity && showPartAdapted"
      :sku-info="skuInfo"
      :adapted-info="partAdaptedInfo"
      @adaptedShow="handlePartAdaptedShow"
      @listShow="handlePartListShow"
    />
    <!-- 参数 -->
    <MoreParameter />
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
import { getParameter } from '@/utils/common'
import { app } from '@/utils'
import MoreParameter from './more-parameter'
import EarnestMoney from './earnest-money'
import trackData from './trackData'
import SellPoints from './sell-points'
import GroupRundown from './group-rundown'
import PartAdaptedType from './part-adapted-type'
import config from '@/config'

export default {
  name: 'ProductInfo',
  components: {
    SellPoints,
    MoreParameter,
    EarnestMoney,
    GroupRundown,
    PartAdaptedType
  },
  props: {
    // 是否是拼团
    isGroupon: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      trackData,
      obj: {}, // 曝光埋点参数
      shopUrl: config.path.shopUrl,
      showExchangeButton: false
    }
  },
  watch: {
    skuInfo: {
      handler(val) {
        this.$nextTick(() => {
          this.dealTrack()
        })
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    ...mapState('detailv3', ['skuInfo', 'spuInfo', 'installmentInit', 'installment']),
    ...mapGetters('detailv3', [
      'currentSuiteInfo',
      'isServiceGoods',
      'isLottery',
      'isVipFirstBuy',
      'isShowPK',
      'stagingInfo',
      'discountType',
      'showPartAdapted',
      'partAdaptedInfo',
      'isShieldPartActivity'
    ]),
    isAtmospherePreHot() {
      return this.skuInfo?.commoditySkuDiscount?.commoditySkuDiscountDetail?.commodityQuickBuyPreHeat?.isAtmosphere == 0
    },
    commodityQuickBuyPreHeat() {
      return this.skuInfo?.commoditySkuDiscount?.commoditySkuDiscountDetail?.commodityQuickBuyPreHeat
    },
    // 获取skuid
    skuId() {
      return this.skuInfo?.commoditySkuBaseInfo?.skuId
    },
    // 文字链
    textLinks() {
      let textLinks = this.relatedSeriesInfo?.textLinks || []
      const result = textLinks.filter(item => item.skuId == this.skuId)
      return result
    },
    // 是否是赠品
    giftSign() {
      return this.spuInfo?.commoditySpu?.giftSign == 1
    },
    // 优惠券会员等级
    couponMemberLevel() {
      const couponList = this.skuInfo?.commoditySkuDiscount?.commodityEstimated?.commodityEstimatedCouponList
      if (couponList && couponList.length > 0) {
        const normal = couponList.filter(item => item.couponMemberLevel == '1').length
        const silver = couponList.filter(item => item.couponMemberLevel == '2').length
        const gold = couponList.filter(item => item.couponMemberLevel == '3').length
        return {
          normal,
          silver,
          gold
        }
      }
      return null
    },
    // 优惠券类型
    couponFlag() {
      const couponList = this.skuInfo?.commoditySkuDiscount?.commodityEstimated?.commodityEstimatedCouponList
      if (couponList && couponList.length > 0) {
        // 优惠券
        const youhui = couponList.filter(item => item.couponFlag == '0').length
        // 代金券
        const daijin = couponList.filter(item => item.couponFlag == '1').length
        return {
          youhui,
          daijin
        }
      }
      return null
    },
    marketPrice() {
      return this.skuInfo?.commoditySkuBaseInfo?.marketPrice || 0
    },
    // 正常价格 先取优惠价，没有就取销售价
    basePrice() {
      const commodityDiscountPrice = this.skuInfo?.commoditySkuDiscount?.commodityDiscountPrice
      if (commodityDiscountPrice) return commodityDiscountPrice
      else return this.skuInfo?.commoditySkuBaseInfo?.salePrice
    },
    // 是否展示积分
    isShowPoint() {
      return this.skuInfo?.commoditySkuDiscount?.commodityPoints?.supportFlag
    },
    relatedSeriesInfo() {
      return this.spuInfo?.relatedSeriesInfo || {}
    }
  },
  methods: {
    ...mapMutations('detailv3', ['CHANGE_ADAPTED_POPUP_SHOW', 'CHANGE_PART_LIST_POPUP_SHOW']),
    ...mapActions('detailv3', ['queryPartAdaptedList']),
    // 跳转至服务条款
    linkTo() {
      let _this = this
      setTimeout(function () {
        let link =
          _this.shopUrl +
          '/helpcenter/vivo-care-pact?' +
          (_this.skuInfo.commoditySkuBaseInfo.svcType == 1
            ? 'broken=1'
            : _this.skuInfo.commoditySkuBaseInfo.svcType == 2
            ? 'extend=1'
            : _this.skuInfo.commoditySkuBaseInfo.svcType == 3
            ? 'backCover=1'
            : _this.skuInfo.commoditySkuBaseInfo.svcType == 4
            ? 'vivoCare=1'
            : _this.skuInfo.commoditySkuBaseInfo.svcType == 5
            ? 'valueChange=1'
            : _this.skuInfo.commoditySkuBaseInfo.svcType == 6
            ? 'accidentFix=1'
            : _this.skuInfo.commoditySkuBaseInfo.svcType == 7
            ? 'renewal=1'
            : _this.skuInfo.commoditySkuBaseInfo.svcType == 8
            ? 'battery=1'
            : _this.skuInfo.commoditySkuBaseInfo.svcType == 9
            ? 'vivoCareNew=1'
            :_this.skuInfo.commoditySkuBaseInfo.svcType == 10
            ? 'vivoCarePlus=1'
            :_this.skuInfo.commoditySkuBaseInfo.svcType == 11
            ? 'vivoCarePlus=1'
            : 'onlyChange=1')
        app.openNewWebview({ url: link })
      }, 400)
    },
    // 跳转商品详情页
    toDetail(item) {
      let url = `${this.linkBase}/product/${item.spuId}`
      const channel = getParameter('channel', window?.productSetJKUrl)
      // 会员先享购专属链接 且 同系列商品参加了会员先享购活动
      if (channel == 'vip' && item.channel) {
        url += '?channel=vip'
      }
      this.openNewWebview(url)
    },
    jump() {
      if (this.isAtmospherePreHot) {
        return
      }
      app.openNewWebview({
        url: this.commodityQuickBuyPreHeat.actUrl
      })
    },
    openNewWebview(url) {
      app.openNewWebview({
        url: url
      })
    },
    changeShowButton(flag) {
      this.showExchangeButton = flag
    },
    handlePartAdaptedShow() {
      // 打开适用说明弹窗
      this.CHANGE_ADAPTED_POPUP_SHOW(true)
      const type = this.partAdaptedInfo.partAdaptedToModelType
      // 如果关系为原装
      // 如果关系为适配，且有原装配件，请求列表
      if (type == 1 || (type == 2 && this.partAdaptedInfo.hasOriginalCmmdy)) {
        this.queryPartAdaptedList()
      }
    },
    handlePartListShow() {
      this.queryPartAdaptedList()
      this.CHANGE_PART_LIST_POPUP_SHOW(true)
    },
    // 埋点
    dealTrack() {
      // info_content: 1:价格显示;2:文字链;3:同系列推荐;4:到手价;5:积分抵现;6:下拉折叠按钮;7:收藏按钮;8:更多活动;9:机型对比
      const price =
        this.skuInfo?.commoditySkuDiscount?.commodityDiscountPrice || this.skuInfo?.commoditySkuBaseInfo?.salePrice
      // 价格显示
      const info_content_1 = !this.giftSign && price >= 0
      // 文字链
      const info_content_2 = this.textLinks.length > 0
      // 同系列推荐
      const info_content_3 = this.relatedSeriesInfo.relateSeries
      // 到手价
      const info_content_4 = this.skuInfo?.commoditySkuDiscount?.commodityEstimated?.commodityEstimatedPrice
      // 积分抵现
      const info_content_5 = this.isShowPoint
      // 下拉折叠按钮
      const info_content_6 = this.showExchangeButton
      // 机型对比,机型对比依赖参数图片
      const info_content_9 = this.isShowPK && this.skuInfo && this.skuInfo.specImgUrl
      // 1-1:含有免息标签;1-2:有活动优惠;1-3:有分期优惠;1-4:包含商城发券/满减活动优惠时;1-5:包含会员券/满减活动优惠;
      // 4-1:到手预估;4-2:黄金专享;4-3:白银专享
      const infoContentType_1_1 = this.installment?.optimalText?.includes('免息')
      const infoContentType_1_2 = this.basePrice < this.marketPrice
      const infoContentType_1_3 = this.stagingInfo
      const infoContentType_1_4 = this.couponFlag && this.couponFlag.youhui
      const infoContentType_1_5 = this.couponMemberLevel != null
      const infoContentType_4_1 = info_content_4
      const infoContentType_4_2 = this.couponMemberLevel == 'gold'
      const infoContentType_4_3 = this.couponMemberLevel == 'silver'
      // recommand_spu: 同系列推荐商品spu
      let recommand_spu = ''
      const info_content = []
      if (info_content_1) {
        const type = !(
          infoContentType_1_1 ||
          infoContentType_1_2 ||
          infoContentType_1_3 ||
          infoContentType_1_4 ||
          infoContentType_1_5
        )
        if (infoContentType_1_1) info_content.push({ info_content_id: 1, info_content_type: '1-1' })
        if (infoContentType_1_2) info_content.push({ info_content_id: 1, info_content_type: '1-2' })
        if (infoContentType_1_3) info_content.push({ info_content_id: 1, info_content_type: '1-3' })
        if (infoContentType_1_4) info_content.push({ info_content_id: 1, info_content_type: '1-4' })
        if (infoContentType_1_5) info_content.push({ info_content_id: 1, info_content_type: '1-5' })
        if (type) info_content.push({ info_content_id: 1 })
      }
      if (info_content_2) {
        info_content.push({ info_content_id: 2 })
      }
      if (info_content_3) {
        info_content.push({ info_content_id: 3 })
        const relateSeries = this.relatedSeriesInfo?.relateSeries || []
        let s = ''
        relateSeries.forEach(item => {
          s = s + item.spuId + ','
        })
        let sLen = s.length
        s = s.slice(0, sLen - 1)
        recommand_spu = s || ''
      }
      if (info_content_4) {
        if (infoContentType_4_1) info_content.push({ info_content_id: 4, info_content_type: '4-1' })
        if (infoContentType_4_2) info_content.push({ info_content_id: 4, info_content_type: '4-2' })
        if (infoContentType_4_3) info_content.push({ info_content_id: 4, info_content_type: '4-3' })
      }
      if (info_content_5) {
        info_content.push({ info_content_id: 5 })
      }
      if (info_content_6) {
        info_content.push({ info_content_id: 6 })
      }
      if (info_content_9) {
        info_content.push({ info_content_id: 9 })
      }
      this.obj = {
        sku_id: this.skuId,
        info_content,
        recommand_spu,
        page_name: this.discountType == 'group' ? 2 : 1
      }
    }
  }
}
</script>

<style lang="scss" scoped src="./index.scss"></style>
<style lang="scss" scoped>
.vivo-fontscale-5 {
  .product-info-wrap .product-info-title .product-tag {
    margin-top: 15px;
  }
}
</style>
